import React from "react";
import { Link } from "react-router-dom";

function ShopDetails() {
  return (
    <div>
      <div className="details bg-gray-100 text-center py-6 px-6">
        <h2 className="pb-4">
          PLUS LOTS MORE PRODUCTS AVAILABLE IN OUR ONLINE SHOP
        </h2>
        <Link to="shop">
          <button className="uppercase bg-black text-white hover:text-black hover:bg-white border-2 border-black transition-all py-2 px-5">
            Visit our shop
          </button>
        </Link>
      </div>
    </div>
  );
}

export default ShopDetails;
